/* A simple iframe wrapper that makes 16:9 responsive embed */

export default ({ url, background = 'white', className = 'video' }) => {
    return (
        <div
            className={className}
            style={{
                position: 'relative',
                background: background,
            }}
        >
            <video width="100%" controls>
                <source src={url} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};
